import React, { MouseEvent } from 'react';
import styled from 'styled-components';

import PhotoGroup from '../../assets/promos/photoGroup.png';
import BackArrow from '../../components/icons/BackArrow';
import {
  BottomModalContainer,
  ModalContainer,
  ModalHeader,
  ModalTitle,
  Overlay,
  TransparentOverlayBottomModal
} from '../../components/modals/CommonModal';
import { BackArrowContainer } from '../InvitePage';
import { DesktopShow, MobileShow } from '../../components/styled/Common';
import { IUEvent } from '../../lib/event';
import { WideWhiteButton } from '../../components/buttons/WhiteButton';
import { WideOutlineButton } from '../../components/buttons/OutlineButton';

const PostRsvpModal = ({ close, event, afterLogin }: {
  close: () => void,
  event: IUEvent,
  afterLogin?: boolean
}) => {
  const handleDownloadShineiOSClick = () => {
    window.open('https://apps.apple.com/us/app/sunshine-photos/id6469663904?itsct=apps_box_badge&amp;itscg=30200',
      '_blank');
  };

  const handleDownloadShineAndroidClick = () => {
    window.open('https://play.google.com/store/apps/details?id=com.lumilabs.android.shine.ga', '_blank');
  };

  const handleDownloadShineMobileClick = () => {
    window.open('https://photos.sunshine.com', '_blank');
  };

  const onModalClick = (e: MouseEvent) => {
    e.stopPropagation();
  };

  const titleText = afterLogin ? 'You\'re signed in' : 'RSVP received';
  const subtitleText = afterLogin
    ? <>Now download the Shine app to effortlessly share photos of <strong>{event?.title ?? 'your party'}.</strong></>
    : <>Now that you’ve responded, download the Shine app to effortlessly share photos
      of <strong>{event?.title ?? 'your party'}.</strong></>;

  const modalContent = <>
    <CardBody>
      <ModalHeader>
        <BackArrowContainer onClick={close}>
          <BackArrow/>
        </BackArrowContainer>
        <ModalTitle>{titleText}</ModalTitle>
      </ModalHeader>
      <TextWrapper>
        {subtitleText}
      </TextWrapper>
      <Image src={PhotoGroup}/>
    </CardBody>
    <ButtonWrapper>
      <DesktopShow>
        <WideWhiteButton $invert={true} onClick={handleDownloadShineiOSClick} disabled={false}>
          Shine for iOS
        </WideWhiteButton>
        <WideOutlineButton onClick={handleDownloadShineAndroidClick} disabled={false}>
          Shine for Android
        </WideOutlineButton>
      </DesktopShow>
      <MobileShow>
        <WideWhiteButton $invert={true} onClick={handleDownloadShineMobileClick} disabled={false}>
          Download Shine
        </WideWhiteButton>
      </MobileShow>
    </ButtonWrapper>
  </>;

  return <>
    <DesktopShow>
      <Overlay onMouseDown={close}>
        <ModalContainer onMouseDown={onModalClick}>
          {modalContent}
        </ModalContainer>
      </Overlay>
    </DesktopShow>
    <MobileShow>
      <TransparentOverlayBottomModal onClick={close}>
        <BottomModalContainer onClick={onModalClick}>
          {modalContent}
        </BottomModalContainer>
      </TransparentOverlayBottomModal>
    </MobileShow>
  </>;
};

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  align-items: center;
`;

const TextWrapper = styled.div``;

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
`;

const Image = styled.img`
  width: 50%;
`;

export default PostRsvpModal;

